import { useTemplateStore } from "../stores/template";

/**
 * Middleware global untuk inisialisasi ringan saat aplikasi berjalan.
 *
 * Saat ini tanggung jawab utamanya adalah memastikan tanggal preview tetap valid
 * melalui `normalizeEventDateForPreview()` sebelum section lain mulai membaca store.
 *
 * @returns Promise yang selesai setelah inisialisasi store dijalankan
 */
export default defineNuxtRouteMiddleware(async () => {
  const nuxtApp = useNuxtApp();

  // Jalankan saat hydration awal agar preview date sudah sinkron sebelum UI membaca state.
  if ((import.meta.client && nuxtApp.isHydrating) || !nuxtApp.isHydrating) {
    const { normalizeEventDateForPreview } = useTemplateStore();

    normalizeEventDateForPreview();
  }
});
